import Box from "./Box";
import HeadingMain from "./HeadingMain";
import React from "react";
import SingleColumnLayout from "./SingleColumnLayout";
import { useAppContext } from "./AppContext";
import ItemWithReturnReason from "./ItemWithReturnReason";
import LozengeButton from "./LozengeButton";
import { ADD_DETAILS } from "../core-modules/constants";
import BodyText from "./BodyText";

function AddReturnReasons() {
  const { setCurrentStep, takebackItems } = useAppContext();

  const itemsNeedingReasons = takebackItems.filter(
    (item) => item.category.getReasons
  );

  return (
    <SingleColumnLayout>
      <Box px={[null, null, null, "7.75vw"]}>
        <HeadingMain pb={35}>Choose your reason:</HeadingMain>
        {itemsNeedingReasons.map((item, index) => {
          return <ItemWithReturnReason key={index} item={item} />;
        })}
        <Box py={40}>
          <BodyText>
            Remember to separate the clothes that are still wearable from the
            ones that need to be recycled. Draw an 'X' using a pen on the brand
            or care label of clothes for recycling, so we know exactly what to
            do.
          </BodyText>
        </Box>
        <Box display="flex" justifyContent="flex-end" pb={70}>
          <LozengeButton
            onClick={() => {
              setCurrentStep(ADD_DETAILS);
            }}
          >
            Submit your takeback
          </LozengeButton>
        </Box>
      </Box>
    </SingleColumnLayout>
  );
}

export default AddReturnReasons;
